import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal } from 'hyperdb-utils';
import api from 'api';
import { ModalEmailAction } from '../../common';

class ItemActions extends React.Component {
  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleToggleModalDelete = this.handleToggleModalDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.deleteSuccessful) {
      this.props.api.routing.redirect(this.props.router, '/daily-rental/inquiries');
    }
    if (nextProps.actionSuccessful) {
      if (nextProps.selectedAction === 'confirm_availability') {
        if (nextProps.createdReservation) {
          this.props.api.routing.redirect(this.props.router, `/daily-rental/reservations/${nextProps.createdReservation.id}`);
        }
      } else {
        const action = nextProps.selectedAction;
        this.props.api.inquiry.setData({ selectedAction: null, actionSuccessful: false });
        if (this.props.onActionSuccessful) this.props.onActionSuccessful();
      }
    }
  }
  componentWillUnmount() {
    this.props.api.inquiry.setData({
      deleteSuccessful: false,
      showModalDelete: false,
      successMessage: null,
      errorMessage: null,
      selectedAction: null,
      actionSuccessful: false,
    });
  }
  render() {
    const inquiry = this.props.inquiry;
    return (
      <div style={{display: 'inline-block'}}>
        <DropdownButton title={ <i className={ `fas fa-cog `} /> } pullRight bsSize="small" id="Menu actions">
          <MenuItem onClick={ this.handleEdit }>Edit</MenuItem>
          <MenuItem onClick={ this.handleToggleModalDelete.bind(this, true) }>Delete</MenuItem>
          <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'send_email') }>Send an email</MenuItem>
          {
            inquiry.available && !inquiry.processed
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'confirm_availability') }>Confirm availability</MenuItem>
              : null
          }
          {
            !inquiry.processed
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'request_information') }>Request information</MenuItem>
              : null
          }
          {
            !inquiry.available && !inquiry.processed
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'notify_unavailable') }>Notify unavailable</MenuItem>
              : null
          }
          {
            !inquiry.processed
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'alternative') }>Suggest an alternative</MenuItem>
              : null
          }
          {
            !inquiry.processed
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'reject') }>Reject</MenuItem>
              : null
          }
          {/*
            inquiry.status === 'new'
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'process_later') }>Process later</MenuItem>
              : null
          */}
          {/*
            inquiry.available && ['new', 'pending', 'processing'].includes(inquiry.status)
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'offer') }>Make an offer</MenuItem>
              : null
          */}
          {/*
            inquiry.status === 'processing'
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'abort') }>Abort</MenuItem>
              : null
          */}
          {/*
            inquiry.status === 'aborted'
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'continue') }>Continue</MenuItem>
              : null
          */}
          {
            inquiry.error_code
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'remove_error') }>Remove error</MenuItem>
              : null
          }
        </DropdownButton>
        {
          this.props.showModalDelete
            ? <Modal
                show={ true }
                onClose={ this.handleToggleModalDelete.bind(this, false) }
                title="Delete"
                loading={ this.props.loading }
                onAccept={ this.handleConfirmDelete }
                labelConfirm="Delete">
                  <span>Are you sure you want to delete this object ?</span>
              </Modal>
            : null
        }
        {
          this.props.selectedAction
            ? <ModalEmailAction
                { ...this.propsForModalAction(this.props.selectedAction) }
                reservation={ this.props.inquiry }
                repliedMessageId={ this.props.repliedMessageId }
                processingAction={ this.props.loading }
                selectedAction={ this.props.selectedAction }
                onClose={ this.handleSelectItemAction.bind(this, null) }
                actionSuccessful={ this.props.postDataSuccessful } />
            : null
        }
      </div>
    );
  }

  handleEdit() {
    this.props.api.routing.redirect(this.props.router, `/daily-rental/inquiries/${this.props.inquiry.id}/edit`);
  }
  handleToggleModalDelete(bool) {
    this.props.api.inquiry.setData({ showModalDelete: bool });
  }
  handleConfirmDelete() {
    this.props.api.inquiry.deleteObject(this.props.inquiry);
  }

  handleSelectItemAction(selectedAction) {
    if (selectedAction === 'alternative') {
      const queryParams = {
        reference: this.props.inquiry.reference,
        arrival_date: this.props.inquiry.arrival_date,
        departure_date: this.props.inquiry.departure_date,
        nb_adults: this.props.inquiry.nb_adults || 0,
        nb_young_adults: this.props.inquiry.nb_young_adults || 0,
        nb_children: this.props.inquiry.nb_children || 0,
        nb_young_children: this.props.inquiry.nb_young_children || 0,
        ignore_conditions: this.props.inquiry.ignore_conditions ? 1 : 0,
      };
      const queryString = Object.keys(queryParams).map(attr => `${attr}=${queryParams[attr]}`).join('&');
      this.props.api.routing.redirect(this.props.router, `/daily-rental/availabilities/search?${queryString}`);
    } else {
      this.props.api.inquiry.setData({ selectedAction, postDataSuccessful: false });
    }
  }
  propsForModalAction(action) {
    let templateCode;
    let templateId;
    let title;
    let onSubmit;
    let forceSendEmail = false;
    let noEmail = false;
    let confirmMessage;
    let defaultSendEmail = false;
    switch (action) {
    case 'send_email':
      forceSendEmail = true;
      templateCode = '101';
      title = 'Send an email';
      onSubmit = this.props.api.inquiry.sendEmail;
      break;
    case 'request_information':
      forceSendEmail = true;
      templateCode = '110';
      title = 'Request information';
      onSubmit = this.props.api.inquiry.sendEmail;
      break;
    case 'confirm_availability':
      templateCode = '112';
      title = 'Confirm availability';
      defaultSendEmail = true;
      onSubmit = this.props.api.inquiry.createOffer;
      break;
    // case 'process_later':
    //   noEmail = true;
    //   confirmMessage = 'Are you sure you want to process this inquiry later ?';
    //   title = 'Process later';
    //   onSubmit = this.props.api.inquiry.processLater;
    //   break;
    case 'reject':
      templateCode = '114';
      title = 'Reject';
      onSubmit = this.props.api.inquiry.reject;
      confirmMessage = 'Are you sure you want to reject this inquiry ?';
      break;
    // case 'offer':
    //   templateCode = '120';
    //   title = 'Make an offer';
    //   onSubmit = this.props.api.inquiry.createOffer;
    //   confirmMessage = this.props.inquiry.strictly_available ? 'Are you sure you want to make an offer ?' : '';
    //   break;
    case 'notify_unavailable':
      forceSendEmail = true;
      templateCode = '114';
      title = 'Notify unavailable';
      onSubmit = this.props.api.inquiry.sendEmail;
      break;
    // case 'abort':
    //   noEmail = true;
    //   confirmMessage = 'Are you sure you want to abort this inquiry ?';
    //   title = 'Abort';
    //   onSubmit = this.props.api.inquiry.abort;
    //   break;
    // case 'continue':
    //   noEmail = true;
    //   confirmMessage = 'Are you sure you want to continue this aborted inquiry ?';
    //   title = 'Continue';
    //   onSubmit = this.props.api.inquiry.continue;
    //   break;
    case 'remove_error':
      noEmail = true;
      confirmMessage = 'Are you sure you want to remove this error ?';
      title = 'Remove error';
      onSubmit = this.props.api.inquiry.removeError;
      break;
    }
    return { templateCode, templateId, title, onSubmit, forceSendEmail, noEmail, confirmMessage, defaultSendEmail };
  }
}

export default api.connect(ItemActions, 'inquiry');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/containers/ItemActions.jsx